export default {
    state: {
        currentSuperBomComponentIndex: -1,
        currentSuperBomComponentIterate: -1,
        sourceSuperBomComponent: [],
        sourceChildrenSuperBomComponent: [],
    },
    actions: {
        async fetchSearchNextMatches(ctx, superBomId) {
            const superBomComponents = ctx.rootState.SuperBomComponentList.superBomComponents
            let currentSuperBomComponentIndex = ctx.state.currentSuperBomComponentIndex
            let res
            let resJson
            const toastWaitId = this._vm.$toast("Searching ...", {timeout: 60000,})
            if ((currentSuperBomComponentIndex + 1) >= superBomComponents.length ||
                currentSuperBomComponentIndex === -1) {
                currentSuperBomComponentIndex = -1
                ctx.state.currentSuperBomComponentIterate = -1
            }
            while ((currentSuperBomComponentIndex + 1) < superBomComponents.length) {
                ctx.state.currentSuperBomComponentIterate++
                currentSuperBomComponentIndex++
                const currentSuperBomComponentId = superBomComponents[currentSuperBomComponentIndex].id
                const requestParams = {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        'credentials': "same-origin",
                    },
                };
                res = await fetch("/product/action/search_next_matches/?super_bom=" +
                    superBomId + '&destination_bom_component=' + currentSuperBomComponentId, requestParams);
                resJson = await res.json();
                const source = resJson['source']
                if ((currentSuperBomComponentIndex + 1) >= superBomComponents.length && source.length === 0) {
                    currentSuperBomComponentIndex = -1
                    break
                }
                if (res.ok != true || source.length !== 0) {
                    break
                }
            }
            if (res.ok) {
                this._vm.$toast.dismiss(toastWaitId)
                this._vm.$toast.success("Success")
            } else {
                this._vm.$toast.dismiss(toastWaitId)
                this._vm.$toast.error("Error:" + resJson['error'], {timeout: 5000})
            }
            ctx.commit('updateCurrentSuperBomComponent', currentSuperBomComponentIndex)
            ctx.commit('updateSearchNextMatches', resJson)
        },
        async fetchMergeMatches(ctx) {
            const toastWaitId = this._vm.$toast("Merging ...", {timeout: 120000,})
            let superBomComponents = JSON.parse(JSON.stringify(ctx.rootState.SuperBomComponentList.superBomComponents))
            const currentSuperBomComponentId = superBomComponents[ctx.state.currentSuperBomComponentIndex].id
            let destinationBomComponent = superBomComponents.filter(bomComponent => bomComponent.id === currentSuperBomComponentId)[0]
            let sourceBomComponents = superBomComponents.filter(bomComponent => ctx.state.sourceSuperBomComponent.includes(bomComponent.id))
            for (let sourceBomComponent of sourceBomComponents) {
                for (let [index, child] of sourceBomComponent.children.entries()) {
                    destinationBomComponent.children.push(child)
                    sourceBomComponent.children.splice(index, 1)
                }
            }
            const jsonUpdateComponent = JSON.stringify(destinationBomComponent)
            const requestUpdateBomComponent = {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    'credentials': "same-origin",
                },
                body: jsonUpdateComponent
            };
            const resUpdateBomComponent = await fetch("/api/bomcomponent/" +
                destinationBomComponent.id + "/", requestUpdateBomComponent)

            if (resUpdateBomComponent.ok) {
                for (let sourceBomComponent of sourceBomComponents) {
                    if (sourceBomComponent.children.length === 0) {
                        const requestOptions = {
                            method: "DELETE",
                            headers: {
                                "Content-Type": "application/json",
                                'credentials': "same-origin",
                            },
                        };
                        await fetch("/api/bomcomponent/" + sourceBomComponent.id + "/", requestOptions)
                        superBomComponents = superBomComponents.filter(bomComponent => bomComponent.id !== sourceBomComponent.id)
                    } else {
                        const jsonUpdateSourceComponent = JSON.stringify(sourceBomComponent)
                        const requestUpdateSourceBomComponent = {
                            method: "PATCH",
                            headers: {
                                "Content-Type": "application/json",
                                'credentials': "same-origin",
                            },
                            body: jsonUpdateSourceComponent
                        };
                        const resUpdateSourceBomComponent = await fetch("/api/bomcomponent/" +
                            sourceBomComponent.id + "/", requestUpdateSourceBomComponent)
                    }
                }
                ctx.commit('updateSuperBomComponents', superBomComponents)
                this._vm.$toast.dismiss(toastWaitId)
                this._vm.$toast.success("Success")
            }
        },
    },

    mutations: {
        updateSearchNextMatches(state, props) {
            state.sourceSuperBomComponent = props['source']
            state.sourceChildrenSuperBomComponent = props['source_children']
        },
        updateCurrentSuperBomComponent(state, props) {
            state.currentSuperBomComponentIndex = props
        }

    },
    getters: {
        destinationSuperBomComponentTableColumns(state, getters, rootState) {
            const superBomComponents = rootState.SuperBomComponentList.superBomComponents
            if (superBomComponents[state.currentSuperBomComponentIndex] != -1 && state.currentSuperBomComponentIndex != -1) {
                const currentSuperBomComponentId = superBomComponents[state.currentSuperBomComponentIndex].id
                const destinationSuperBomComponent = rootState.SuperBomComponentList.superBomComponents.filter(bomComponent => currentSuperBomComponentId === bomComponent.id)
                return destinationSuperBomComponent
            } else {
                return []
            }
        },
        sourceSuperBomComponentTableColumns(state, getters, rootState) {
            let sourceSuperBomComponents = rootState.SuperBomComponentList.superBomComponents.filter(bomComponent => state.sourceSuperBomComponent.includes(bomComponent.id))
            for (let sourceSuperBomComponent of sourceSuperBomComponents)
                for (let child of sourceSuperBomComponent.children) {
                    child.vgtSelected = state.sourceChildrenSuperBomComponent.includes(child.id);
                }
            return sourceSuperBomComponents
        },
        findPercent(state, getters, rootState) {
            return Number((100 * (state.currentSuperBomComponentIterate + 1) / rootState.SuperBomComponentList.superBomComponents.length).toFixed(1))
        }
    },
}
